const feature_cards = [
  {
    icon: "bi bi-buildings",
    title: "Portfolio Owners",
    text: "Centralises property performance, utility health, and operational exceptions across every site in your portfolio.",
  },
  {
    icon: "bi bi-lightning-charge-fill",
    title: "Utilities Teams",
    text: "Tracks consumption patterns, meter activity, and service status so teams can act before usage problems grow.",
  },
  {
    icon: "bi bi-wifi",
    title: "Operations Managers",
    text: "Gives daily visibility into site issues, live statuses, and the signals that need quick attention.",
  },
  {
    icon: "bi bi-shield-lock-fill",
    title: "Security Teams",
    text: "Keeps access, verification, and site-level security context clear inside one controlled workspace.",
  },
  {
    icon: "bi bi-bar-chart-line",
    title: "Executives",
    text: "Turns portfolio movement into readable intelligence for faster reporting, comparison, and planning.",
  },
  {
    icon: "bi bi-router",
    title: "Connectivity Teams",
    text: "Surfaces online and offline service health so data gaps and infrastructure issues are easier to resolve.",
  },
];

const insight_points = [
  "Property-level visibility across utilities, consumption, security, and connectivity.",
  "Clear status language for teams who need quick operational context.",
  "A focused experience designed around recurring daily portfolio checks.",
];

export default {
  name: "FeatureSection",
  data: () => ({
    feature_cards,
    insight_points,
  }),
};
